
define("json!taoItems/preview/resources/device-list.json", function(){ return {
    "tablets": {
        "193986c3715c81838870f908fa98d69a": {
            "label": "Amazon Kindle Fire HDX 7\u2033",
            "width": 960,
            "height": 600
        },
        "4e8eafab11aad1486992d7ee2c8c16ca": {
            "label": "Apple iPad",
            "width": 1024,
            "height": 768
        },
        "5aac2932d9ad00d6d8a1604b8f9e4e8d": {
            "label": "Google Nexus 10, Motorola Xoom, Xyboard",
            "width": 1280,
            "height": 800
        },
        "9805d9753ad08c7630a9ee5418aa6c6c": {
            "label": "Google Nexus 7",
            "width": 966,
            "height": 604
        },
        "d4a431cedf4705d6bf2cba6d5788378b": {
            "label": "Samsung Galaxy Tab 7.7, 8.9, 10.1",
            "width": 1280,
            "height": 800
        }
    },
    "phones": {
        "1b89338531ef0155c8d6abc2ac02c81a": {
            "label": "Apple iPhone 3GS",
            "width": 320,
            "height": 480,
            "scaleFactor": 1,
            "dpWidth": 320,
            "dpHeight": 480
        },
        "3f89da99d84214cde7df87ebe0699a6f": {
            "label": "Apple iPhone 4",
            "width": 640,
            "height": 960,
            "scaleFactor": 2,
            "dpWidth": 320,
            "dpHeight": 1920
        },
        "0d36971a5b98b367f54ced708c9af849": {
            "label": "Apple iPhone 5",
            "width": 640,
            "height": 1136,
            "scaleFactor": 2,
            "dpWidth": 320,
            "dpHeight": 2272
        },
        "026beffcc051af995660ebdede986ace": {
            "label": "BlackBerry Z10",
            "width": 768,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 384,
            "dpHeight": 2560
        },
        "fd2dd53e667d6d49e4fa73356fa941dd": {
            "label": "BlackBerry Z30",
            "width": 720,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 360,
            "dpHeight": 2560
        },
        "707584c1ae17d9b5b2cbe8603c91c147": {
            "label": "Google Nexus 4",
            "width": 768,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 384,
            "dpHeight": 2560
        },
        "91823264de952e7f2347e07db5c4058b": {
            "label": "Google Nexus 5",
            "width": 1080,
            "height": 1920,
            "scaleFactor": 3,
            "dpWidth": 360,
            "dpHeight": 5760
        },
        "cd69817a6e147e8a4677389e56fcf568": {
            "label": "Google Nexus S",
            "width": 480,
            "height": 800,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1200
        },
        "75994faa6a38e31e99b53fcd75534a33": {
            "label": "HTC Evo, Touch HD, Desire HD, Desire",
            "width": 480,
            "height": 800,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1200
        },
        "0cab4dfccdfc880687cb608cfe4159db": {
            "label": "HTC One X, EVO LTE",
            "width": 720,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 360,
            "dpHeight": 2560
        },
        "c4ff41fcba24d74fc21dc3490ca1edc9": {
            "label": "HTC Sensation, Evo 3D",
            "width": 540,
            "height": 960,
            "scaleFactor": 1.5,
            "dpWidth": 360,
            "dpHeight": 1440
        },
        "fa969a5e0dd2de53700eeee4ba4ba142": {
            "label": "LG Optimus 2X, Optimus 3D, Optimus Black",
            "width": 480,
            "height": 800,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1200
        },
        "33c4f9364e295ec03531f3a3425819cf": {
            "label": "LG Optimus G",
            "width": 768,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 384,
            "dpHeight": 2560
        },
        "bc47f5275f0efd56fee52d43a8082981": {
            "label": "LG Optimus LTE, Optimus 4X HD",
            "width": 720,
            "height": 1280,
            "scaleFactor": 1.7,
            "dpWidth": 424,
            "dpHeight": 2176
        },
        "0732887e6e324fd10777b735520a34cf": {
            "label": "LG Optimus One",
            "width": 320,
            "height": 480,
            "scaleFactor": 1.5,
            "dpWidth": 213,
            "dpHeight": 720
        },
        "2e38a78364f09d0da0e9e1a3a68e7fb0": {
            "label": "Motorola Defy, Droid, Droid X, Milestone",
            "width": 480,
            "height": 854,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1281
        },
        "bd4b78dddc7c9625a4141a1b1ddabb87": {
            "label": "Motorola Droid 3, Droid 4, Droid Razr, Atrix 4G, Atrix 2",
            "width": 540,
            "height": 960,
            "scaleFactor": 1,
            "dpWidth": 540,
            "dpHeight": 960
        },
        "3bf1edf21cfa81006183d2b02974c84e": {
            "label": "Motorola Droid Razr HD",
            "width": 720,
            "height": 1280,
            "scaleFactor": 1,
            "dpWidth": 720,
            "dpHeight": 1280
        },
        "ab5a352e0e016b97dac986f06c394f55": {
            "label": "Nokia C5, C6, C7, N97, N8, X7",
            "width": 360,
            "height": 640,
            "scaleFactor": 1,
            "dpWidth": 360,
            "dpHeight": 640
        },
        "4826fb7d7257aeaac992ce699df41b3c": {
            "label": "Nokia Lumia 7X0, Lumia 8XX, Lumia 900, N800, N810, N900",
            "width": 480,
            "height": 800,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1200
        },
        "0a691ab20add7c432200f8fa6527b488": {
            "label": "Samsung Galaxy Note",
            "width": 800,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 400,
            "dpHeight": 2560
        },
        "9c23ee31be29960fbac9e9bbfc2fc7b0": {
            "label": "Samsung Galaxy Note 3",
            "width": 1080,
            "height": 1920,
            "scaleFactor": 2,
            "dpWidth": 540,
            "dpHeight": 3840
        },
        "92177c0508c1d73905a58e2338f2a81f": {
            "label": "Samsung Galaxy Note II",
            "width": 720,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 360,
            "dpHeight": 2560
        },
        "5222b8866dc4cc606725e16ffcc0a783": {
            "label": "Samsung Galaxy S III, Galaxy Nexus",
            "width": 720,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 360,
            "dpHeight": 2560
        },
        "37c1541e2bd55cfd0f4073b0ccdf68b3": {
            "label": "Samsung Galaxy S, S II, W",
            "width": 480,
            "height": 800,
            "scaleFactor": 1.5,
            "dpWidth": 320,
            "dpHeight": 1200
        },
        "2f7f64b7dda0144907ff300e83eed465": {
            "label": "Samsung Galaxy S4",
            "width": 1080,
            "height": 1920,
            "scaleFactor": 3,
            "dpWidth": 360,
            "dpHeight": 5760
        },
        "9c24f9057744dad56043702a9703127f": {
            "label": "Sony Xperia S, Ion",
            "width": 720,
            "height": 1280,
            "scaleFactor": 2,
            "dpWidth": 360,
            "dpHeight": 2560
        },
        "0a8b2732a016a9395c3af5f12dd9c0da": {
            "label": "Sony Xperia Sola, U",
            "width": 480,
            "height": 854,
            "scaleFactor": 1,
            "dpWidth": 480,
            "dpHeight": 854
        },
        "5a153d7f53d82dcb0801f041574a6a43": {
            "label": "Sony Xperia Z, Z1",
            "width": 1080,
            "height": 1920,
            "scaleFactor": 3,
            "dpWidth": 360,
            "dpHeight": 5760
        }
    },
    "screens": {
        "9e523ae15b61dc766f5c818726881ecf": {
            "label": "1920 \u00d7 1080",
            "width": 1920,
            "height": 1080,
            "dpWidth": 1920,
            "dpHeight": 1080,
            "scaleFactor": 1
        },
        "07769cd8d0a7d09818b2f0b018042fb7": {
            "label": "1366 \u00d7 768",
            "width": 1366,
            "height": 768,
            "dpWidth": 1366,
            "dpHeight": 768,
            "scaleFactor": 1
        },
        "72d5478a24194f98b9378e8e0fd65737": {
            "label": "1280 \u00d7 1024",
            "width": 1280,
            "height": 1024,
            "dpWidth": 1280,
            "dpHeight": 1024,
            "scaleFactor": 1
        },
        "b7a6dd5900cc72e61f0d3479c7e314ec": {
            "label": "1280 \u00d7 800",
            "width": 1280,
            "height": 800,
            "dpWidth": 1280,
            "dpHeight": 800,
            "scaleFactor": 1
        },
        "43193b0ff671a37d8232ab664190a125": {
            "label": "1024 \u00d7 768",
            "width": 1024,
            "height": 768,
            "dpWidth": 1024,
            "dpHeight": 768,
            "scaleFactor": 1
        },
        "c29e48814af5443ff5688d9e967ce917": {
            "label": "800 \u00d7 600",
            "width": 800,
            "height": 600,
            "dpWidth": 800,
            "dpHeight": 600,
            "scaleFactor": 1
        }
    }
};});

